import {
  EnumActivityType,
  EnumIroOverrideStatus,
  EnumIroStatus,
  EnumIroType,
  type IroType,
} from '~/types/types'

export const getIrosByType = (iroLinks, type: EnumIroType) => {
  // the link could be stakeholder, task, etc...
  if (!Array.isArray(iroLinks)) return []
  return iroLinks.filter((link) => link.iro?.type === type)
}

export const getActivityChipStyle = (type?: EnumActivityType) => {
  switch (type) {
    case EnumActivityType.Downstream:
      return {
        'border-radius': '0 16px 16px 0',
        border: '1px solid #5B7185',
        'font-weight': 'bold',
      }
    case EnumActivityType.Upstream:
      return {
        'border-radius': '16px 0 0 16px',
        border: '1px solid #5B7185',
        'font-weight': 'bold',
      }
    case EnumActivityType.Own:
      return {
        'border-radius': '16px',
        border: '1px solid #5B7185',
        'font-weight': 'bold',
      }
    default:
      return {
        'border-radius': '16px',
        border: '1px solid #5B7185',
        'font-weight': 'bold',
      }
  }
}

export const getActivityChipText = (
  type?: EnumActivityType,
  locale?: string,
) => {
  switch (type) {
    case EnumActivityType.Upstream:
      return locale === 'de' ? 'UP' : 'UP'
    case EnumActivityType.Downstream:
      return locale === 'de' ? 'DOWN' : 'DOWN'
    case EnumActivityType.Own:
      return locale === 'de' ? 'EIGEN' : 'OWN'
    default:
      return ''
  }
}

export const getMaterialityChipColor = (iro: IroType) => {
  if (!iro || iro.status === EnumIroStatus.NotAssessed) {
    return '#F3F8FB'
  }

  // for now hard code based on I or RO
  if (
    iro.type === EnumIroType.PositiveImpact ||
    iro.type === EnumIroType.NegativeImpact
  ) {
    if (iro.status === EnumIroStatus.Material) {
      return '#DA575E' // impact material
    } else {
      return '#8FA5AF' // not material
    }
  } else if (
    iro.type === EnumIroType.Risk ||
    iro.type === EnumIroType.Opportunity
  ) {
    if (
      iro.status === EnumIroStatus.Material ||
      iro.overrideStatus === EnumIroOverrideStatus.Material
    ) {
      return '#00679E' // financial material
    } else {
      return '#8FA5AF' // not material
    }
  }
}

export const getMaterialityChipText = (iro: IroType) => {
  if (!iro) return ''

  // for now hard code based on I or RO
  if (iro.status === EnumIroStatus.NotAssessed) {
    return 'NA'
  }
  if (
    iro.type === EnumIroType.PositiveImpact ||
    iro.type === EnumIroType.NegativeImpact
  ) {
    if (
      iro.status === EnumIroStatus.Material ||
      iro.overrideStatus === EnumIroOverrideStatus.Material
    ) {
      return 'IM' // impact material
    } else {
      return 'NM' // not material
    }
  } else if (
    iro.type === EnumIroType.Risk ||
    iro.type === EnumIroType.Opportunity
  ) {
    if (
      iro.status === EnumIroStatus.Material ||
      iro.overrideStatus === EnumIroOverrideStatus.Material
    ) {
      return 'FM' // opportunity material
    } else {
      return 'NM' // not material
    }
  }
}
